// extracted by mini-css-extract-plugin
export default {"loadingContainer":"ProtectedRoute_loadingContainer__rhM5j"};